import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { OrderCallConfirmation } from "../../orders.types";
import { requestSetOrderCallConfirmation } from "./setOrderCallConfirmation.request";
import { SetOrderCallConfirmationVariables } from "./setOrderCallConfirmation.types";

const useSetOrderCallConfirmation = (
  options?: MutationOptions<
    OrderCallConfirmation,
    ApiServiceError<ApiError>,
    SetOrderCallConfirmationVariables
  >
) => {
  return useMutation({
    mutationFn: requestSetOrderCallConfirmation,
    ...options
  });
};

export default useSetOrderCallConfirmation;
